export function formatAMPM(date) {
  let hours = date.getUTCHours()
  let minutes = date.getUTCMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours || 12 // Handle midnight (0 hours)
  minutes = minutes < 10 ? '0' + minutes : minutes
  const strTime = hours + ':' + minutes + ' ' + ampm
  return strTime
}
